'use client';

import Script from 'next/script';
import { useEffect } from 'react';

interface Props {
    propertyPath: string;
}

declare global {
    interface Window {
        Tawk_API?: {
            hideWidget?: () => void;
        };
        Tawk_LoadStart?: Date;
    }
}

export function TawkWidget({ propertyPath }: Props) {
    useEffect(() => {
        return () => {
            try {
                window.Tawk_API?.hideWidget?.();
            } catch {}

            const tawkSelectors = [
                '#tawk-to',
                'iframe[src*="tawk.to"]',
                'iframe[title*="chat" i]',
                'div[class*="widget-visible"]',
            ];

            tawkSelectors.forEach(selector => {
                document.querySelectorAll(selector).forEach(el => el.remove());
            });

            if (window.Tawk_API) {
                delete window.Tawk_API;
            }
            if (window.Tawk_LoadStart) {
                delete window.Tawk_LoadStart;
            }
        };
    }, []);

    return (
        <>
            <Script
                id="tawk-to-init"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: 'window.Tawk_API=window.Tawk_API||{};window.Tawk_LoadStart=new Date();',
                }}
            />
            <Script
                id="tawk-to"
                src={`https://embed.tawk.to/${propertyPath}`}
                strategy="afterInteractive"
                crossOrigin="anonymous"
                charSet="UTF-8"
            />
        </>
    );
}
